import * as React from 'react';
import {FunctionComponent} from 'react';
import {GraphableSnippet} from '../Models/GraphableSnippet';
import {PlainMultiGraph} from './PlainMultiGraph';
import {stringToColorHex} from '../../Utils/stringToColorRgb';
import {Stroke} from '../../../../../../Models/Stroke';
import {formatDuration} from '../../../../../Support/Formatting/formatDuration';
import {Duration} from '../../../../../../Domain/Duration';

interface OwnProps {
    normaliseXAxis: boolean;
    graphableSnippets: GraphableSnippet[];
    selectYValue: (stroke: Stroke) => number;
    formatY: (value: number) => string;
}

export const BaseGraph: FunctionComponent<OwnProps> = ({normaliseXAxis, graphableSnippets, selectYValue, formatY}) => {
    if (normaliseXAxis) {
        return (
            <PlainMultiGraph
                height={80}
                padding={{top: 0, right: 0, bottom: 20, left: 20}}
                formatY={formatY}
                formatX={(fraction) => {
                    return '' + Math.round(fraction * 100);
                }}
                sets={graphableSnippets.map((graphableSnippet) => {
                    const range =
                        graphableSnippet.strokes[graphableSnippet.strokes.length - 1].totalTime.milliseconds -
                        graphableSnippet.strokes[0].totalTime.milliseconds;
                    return {
                        color: stringToColorHex('' + graphableSnippet.snippet.id),
                        values: graphableSnippet.strokes.map((stroke) => {
                            return {
                                x:
                                    (stroke.totalTime.milliseconds -
                                        graphableSnippet.strokes[0].totalTime.milliseconds) /
                                    range,
                                y: selectYValue(stroke),
                            };
                        }),
                    };
                })}
            />
        );
    }

    return (
        <PlainMultiGraph
            height={80}
            padding={{top: 0, right: 0, bottom: 20, left: 20}}
            formatY={formatY}
            formatX={(totalTimeMilliseconds) =>
                formatDuration(Duration.fromMilliseconds(totalTimeMilliseconds)).formatted
            }
            sets={graphableSnippets.map((graphableSnippet) => {
                return {
                    color: stringToColorHex('' + graphableSnippet.snippet.id),
                    values: graphableSnippet.strokes.map((stroke) => {
                        return {
                            x: stroke.totalTime.milliseconds - graphableSnippet.strokes[0].totalTime.milliseconds,
                            y: selectYValue(stroke),
                        };
                    }),
                };
            })}
        />
    );
};
